import React from "react";

function ComponentCard({ isSelected, getComponentData, index, item, getIcon }) {
  return (
    <div
      key={index}
      className={`h-[58px] ${
        isSelected ? "bg-[--bg-color-500]" : "bg-[#F3F7FE]"
      } rounded flex items-center space-x-2 px-2 cursor-pointer relative`}
      onClick={() => getComponentData(item)}
    >
      {item.is_immutable && (
        <span
          className={`fa-solid fa-lock text-xs absolute right-1 top-1 ${
            isSelected ? "text-[#F3F7FE]" : "text-[#1E293B]"
          }`}
        ></span>
      )}
      <div className="w-[15%] flex justify-center items-center text-lg">
        {getIcon(item.type, isSelected)}
      </div>
      <div className="space-y-0.5 w-2/3">
        <h5
          title={item.label}
          className={`text-sm leading-5 font-semibold text-[#1E293B tracking-tight] w-full overflow-hidden truncate ${
            isSelected ? "text-[#F3F7FE]" : "text-[#1E293B]"
          }`}
        >
          {item.label}
        </h5>
        <p
          title={item.component_name}
          className={`${
            isSelected ? "text-[#F3F7FE]" : "text-[#475569]"
          } text-xs leading-4 tracking-tight w-full overflow-hidden truncate`}
        >
          {item.component_name}
        </p>
      </div>
    </div>
  );
}

export default ComponentCard;
